import script from "./window.vue?vue&type=script&setup=true&lang=js"
export * from "./window.vue?vue&type=script&setup=true&lang=js"

import "./window.vue?vue&type=style&index=0&id=62de9320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62de9320"]])

export default __exports__